import { useCallback, useEffect, useState } from 'react'
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk'

export function useEmbeddingContext() {
  const [embeddingContext, setEmbeddingContext] = useState<EmbeddingContext | null>(null)

  const getEmbeddingContext = useCallback(async () => {
    const context = await createEmbeddingContext()

    setEmbeddingContext(context)
  }, [])

  useEffect(() => {
    getEmbeddingContext()

    return () => {
      setEmbeddingContext(null)
    }
  }, [getEmbeddingContext])

  return embeddingContext
}
